/* =====================================================================
   UNIVERSEPARFUMS — Product Accordion (v2)
   - Desktop : hover ou click (selon settings)
   - Mobile  : IntersectionObserver — le panneau visible devient actif
   ===================================================================== */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 749;

  function initAccordion(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('.up-product__panel'));
    if (!panels.length) return;

    var trigger = root.dataset.trigger || 'hover';

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function setActivePanel(targetIndex) {
      panels.forEach(function (panel, i) {
        if (i === targetIndex) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }

    /* =================================================================
       DESKTOP — hover ou click
       ================================================================= */

    if (trigger === 'hover') {
      panels.forEach(function (panel, i) {
        panel.addEventListener('mouseenter', function () {
          if (isMobile()) return;
          setActivePanel(i);
        });
      });
    }

    if (trigger === 'click') {
      panels.forEach(function (panel, i) {
        var link = panel.querySelector('.up-product__panel-link');
        if (!link) return;
        link.addEventListener('click', function (e) {
          if (isMobile()) return;
          if (!panel.classList.contains('is-active')) {
            e.preventDefault();
            setActivePanel(i);
          }
        });
      });
    }

    /* =================================================================
       MOBILE — IntersectionObserver scroll-based
       ================================================================= */

    var panelRatios = new Array(panels.length).fill(0);
    var rafScheduled = false;

    function recomputeActive() {
      rafScheduled = false;
      if (!isMobile()) return;

      var maxRatio = 0;
      var activeIndex = -1;
      panelRatios.forEach(function (ratio, i) {
        if (ratio > maxRatio) {
          maxRatio = ratio;
          activeIndex = i;
        }
      });

      if (activeIndex >= 0 && maxRatio > 0.3) {
        setActivePanel(activeIndex);
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var index = parseInt(entry.target.dataset.panelIndex, 10);
          if (isNaN(index)) return;
          panelRatios[index] = entry.intersectionRatio;
        });

        if (!rafScheduled) {
          rafScheduled = true;
          window.requestAnimationFrame(recomputeActive);
        }
      }, {
        // Beaucoup de seuils pour une mise à jour fluide pendant le scroll
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      });

      panels.forEach(function (panel) { observer.observe(panel); });
    }

    /* =================================================================
       Resize : reset propre quand on passe mobile <-> desktop
       ================================================================= */

    var lastWasMobile = isMobile();
    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile !== lastWasMobile) {
        lastWasMobile = nowMobile;
        if (!nowMobile) {
          // Retour desktop : on remet le premier comme actif
          setActivePanel(0);
        }
        // Si on passe mobile, l'observer va recalculer tout seul
      }
    });
  }

  function init() {
    document.querySelectorAll('.up-product').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var accordion = e.target.querySelector('.up-product');
    if (accordion) initAccordion(accordion);
  });
})();
